import { render, staticRenderFns } from "./CreateWorkflow.vue?vue&type=template&id=59bef700&scoped=true&"
import script from "./CreateWorkflow.vue?vue&type=script&lang=js&"
export * from "./CreateWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./CreateWorkflow.vue?vue&type=style&index=0&id=59bef700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bef700",
  null
  
)

export default component.exports